import { Controller } from "@hotwired/stimulus"

// Cascada categoría → medio → sub-asesor, y exclusión período ↔ rango de fechas.
export default class extends Controller {
  static targets = [
    "category", "source", "contact", "contactGroup", "sourceOption", "contactOption",
    "advanced", "period", "startDate", "endDate"
  ]

  connect() {
    this.filterSources()
    this.filterContacts()
  }

  toggleAdvanced() {
    if (!this.hasAdvancedTarget) return

    this.advancedTarget.classList.toggle("hidden")
  }

  periodChanged() {
    this.clearDateRange()
    this.element.requestSubmit()
  }

  rangeChanged() {
    if (!this.hasCompleteDateRange()) return

    if (this.hasPeriodTarget) this.periodTarget.value = ""
    this.element.requestSubmit()
  }

  hasCompleteDateRange() {
    return this.hasStartDateTarget && this.hasEndDateTarget &&
      this.startDateTarget.value && this.endDateTarget.value
  }

  clearDateRange() {
    if (this.hasStartDateTarget) this.startDateTarget.value = ""
    if (this.hasEndDateTarget) this.endDateTarget.value = ""
  }

  filterSources() {
    const categoryId = this.categoryTarget.value

    this.sourceOptionTargets.forEach((option) => {
      if (!option.value) return
      const match = !categoryId || option.dataset.category === categoryId
      option.hidden = !match
      option.disabled = !match
    })

    const selected = this.sourceTarget.selectedOptions[0]
    if (selected && selected.disabled) {
      this.sourceTarget.value = ""
    }

    this.filterContacts()
  }

  filterContacts() {
    const sourceId = this.sourceTarget.value
    let visibleCount = 0

    this.contactOptionTargets.forEach((option) => {
      if (!option.value) return
      const match = sourceId && option.dataset.source === sourceId
      option.hidden = !match
      option.disabled = !match
      if (match) visibleCount += 1
    })

    const selected = this.contactTarget.selectedOptions[0]
    if (selected && selected.disabled) {
      this.contactTarget.value = ""
    }

    if (this.hasContactGroupTarget) {
      this.contactGroupTarget.classList.toggle("hidden", visibleCount === 0)
    }
  }
}
